import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { GoogleReview } from '../../models/google/google.dto';
import { UrlService } from '../url/url.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleService {

  constructor(private http: HttpClient, private urlService: UrlService) { }

  /**
   * Retrieves all the google reviews.
   *
   * @example
   * ```typescript
   * // Use this in Components and traditional Services
   * this.flowApiService.getGoogleReviews();
   *
   * // Use this in Interceptors, Guards and Functions
   * flowApiService.getGoogleReviews();
   * ```
   *
   * @param params - Flow params dto
   * @returns Observable<PaginatedFlowsDto> - All google reviews
   */
  getGoogleReviews(): Observable<GoogleReview[]> {
    const url = this.urlService.getGoogleReviewUrl();

    return this.http.get<GoogleReview[]>(url, { observe: 'response' }).pipe(
      map((response: HttpResponse<GoogleReview[]>) => {
        const googleReviews = response.body ?? [];

        return googleReviews;
      }),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }
}
